import { Button } from 'tea-component';
import ToggleAllItems from '@gp/components/ToggleAllItems';
import './index.scss';
import GRActionItem from '../GRActionItem';
import classnames from 'classnames';
import { isEmpty } from 'lodash-es';
// @ts-ignore
import React, { useState, useMemo } from 'react';
import Loading from '@gp/components/Loading';
import { useDeepCompareEffect, useSize } from 'ahooks';
import { Bubble } from '@home/components/TeaComponents';
import { CONSTANT_TEXTS, PERMISSION_APPLY_URL } from '@gp/constants/const';
import NoData from '@gp/components/NoData';
import Tables from '../Tables';

const GRActionTableCard: React.FC<any> = (props) => {
  const {
    className,
    data,
    isShowAll = false,
    loading,
    error,
    onSortChange,
    onRetry,
    onEdit,
    onReset,
    sort,
    toggleIsShowAll,
  } = props;

  const { width } = useSize(document.body) || {};

  const [sortData, setSortData] = useState<any>({
    by: 'project',
    order: 'asc',
  });
  useDeepCompareEffect(() => {
    if (Array.isArray(sort) && sort?.length > 0) {
      const sortValueList = sort?.filter((item: any) => ['project', 'gate_review'].includes(item.by)) || [];
      if (Array.isArray(sortValueList) && sortValueList?.length > 0) {
        setSortData(sortValueList[0]);
      }
    }
  }, [sort]);

  const handleTypeSort = (by: string) => {
    // 如果两个都为空，或者点的另一个
    if (isEmpty(sortData) || sortData?.by !== by) {
      const newSortData = { by, order: 'asc' };
      setSortData(newSortData);
      onSortChange?.([newSortData, { by: 'due_date', order: 'asc' }]);
    } else {
      // 否则点的本身
      if (sortData?.order === 'desc') {
        setSortData([]);
        onSortChange?.([{ by: 'due_date', order: 'asc' }]);
      } else {
        const newSortData = { by, order: 'desc' };
        setSortData(newSortData);
        onSortChange?.([newSortData, { by: 'due_date', order: 'asc' }]);
      }
    }
  };

  const noDataTextCur = useMemo(() => {
    return (
      <div className="dbg-nodata-div">
        <span className="dbg-nodata-normal-span">{`No data found for the selected filters. Please adjust your filters or click '`}</span>
        <span className="dbg-nodata-reset-a-span" onClick={onReset}>
          {'Reset'}
        </span>
        <span className="dbg-nodata-normal-span">{`' to turn all filters off.`}</span>
      </div>
    );
  }, [onReset]);

  return (
    <div
      className={classnames('dbg-gr-action-card', {
        'dbg-gr-action-items-tables-small': width !== undefined && width <= 1540,
      })}
    >
      <div className="dbg-gr-action-card-header">
        <div className="dbg-gr-action-sort-tab">
          <div
            className={classnames('dbg-gr-action-sort-tab-item', {
              '--active': sortData?.by === 'project',
            })}
            onClick={() => handleTypeSort('project')}
          >
            <span>Project</span>
            <i
              className={classnames('dbg-icon-sort', {
                '--down': sortData?.by === 'project' && sortData?.order === 'asc',
                '--up': sortData?.by === 'project' && sortData?.order === 'desc',
              })}
            ></i>
          </div>
          <div
            className={classnames('dbg-gr-action-sort-tab-item', {
              '--active': sortData?.by === 'gate_review',
            })}
            onClick={() => handleTypeSort('gate_review')}
          >
            <span>Review Date</span>
            <i
              className={classnames('dbg-icon-sort', {
                '--down': sortData?.by === 'gate_review' && sortData?.order === 'asc',
                '--up': sortData?.by === 'gate_review' && sortData?.order === 'desc',
              })}
            ></i>
          </div>
        </div>
        <div className="dbg-gr-action-card-header-right">
          <ToggleAllItems isShowAll={isShowAll} onToggleIsShowAll={toggleIsShowAll} />
        </div>
      </div>
      <div className="dbg-gr-action-card-body">
        {loading ? (
          <Loading loading style={{ height: 200, marginTop: 20 }} />
        ) : !data?.length ? (
          <NoData text={noDataTextCur} height={200} constomStyle={{ fontSize: 14 }} />
        ) : (
          <>
            {data?.map((item: any, index: any) => {
              const { edit: editablePermission = false } = item || {};
              return (
                <div className="dbg-gr-action-card-table" key={index}>
                  <div className="dbg-gr-action-card-table-header">
                    <div className="dbg-gr-action-project">
                      <GRActionItem data={item} />
                      <div className="dbg-gr-action-project-right">
                        <Bubble
                          className="dbg-bubble-max-width"
                          dark
                          arrowPointAtCenter
                          placement="top-end"
                          content={
                            editablePermission ? undefined : (
                              <>
                                No edit permission.
                                <br />
                                <a target="_blank" rel="noreferrer" href={PERMISSION_APPLY_URL}>
                                  GPOP Access Application Form
                                </a>{' '}
                                to request edit permission.
                              </>
                            )
                          }
                        >
                          <Button
                            type="link"
                            disabled={!editablePermission}
                            onClick={(e) => {
                              e?.stopPropagation();
                              if (!editablePermission) return;
                              onEdit?.(item);
                            }}
                          >
                            {CONSTANT_TEXTS.EDIT}
                          </Button>
                        </Bubble>
                      </div>
                    </div>
                  </div>

                  <div className="dbg-gr-action-card-table-content">
                    <Tables
                      className={className}
                      loading={loading}
                      error={error}
                      isShowAll={isShowAll}
                      data={item}
                      onRetry={onRetry}
                      onReset={onReset}
                      onEdit={onEdit}
                    />
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
      <div className="dbg-gr-action-card-footer">{data?.length || 0} item in total</div>
    </div>
  );
};

export default GRActionTableCard;
